import './IconMap.scss';
import React from 'react';
import { ReactComponent as CheckCircle } from 'assets/icons/check-no-circle.svg';
import { ReactComponent as Blocks } from 'assets/icons/blocks.svg';
import { ReactComponent as People } from 'assets/icons/people.svg';
import { ReactComponent as Shield } from 'assets/icons/shield.svg';
import { ReactComponent as Calendar } from 'assets/icons/automatic-buy-calendar.svg';
import { ReactComponent as InvestmentVehicleGroup } from 'assets/icons/investment-vehicles.svg';
import { ReactComponent as Currency } from 'assets/icons/money-coins.svg';
import { ReactComponent as FinanceIcon } from 'assets/icons/finance.svg';
import { isMissionComplete } from './utils/MissionUtils';
import { MAINTENANCE_METHODS } from '../../../services/OnBoardingJourney';

//TODO: Check the css on the icons, Finance Icon in the modal is very small
const IconMap = ({ currentIndex, status, action }) => {
  switch (true) {
    case isMissionComplete(status):
      return <CheckCircle className="completed-check" />;
    case action === MAINTENANCE_METHODS.BROKERAGE_TRADING:
      return <Blocks className="mission-icon" />;
    case action === MAINTENANCE_METHODS.BENEFICIARY:
      return <People className="mission-icon" />;
    case action === MAINTENANCE_METHODS.RECURRING_BUY:
      return <Calendar className="mission-icon" />;
    case action === MAINTENANCE_METHODS.TRUSTED_CONTACT:
      return <Shield className="mission-icon" />;
    case action === 'IV':
      return <InvestmentVehicleGroup className="mission-icon" />;
    case action === 'FUNDING':
      return <Currency className="mission-icon" />;
    case action === 'FINANCE':
      return <FinanceIcon className="mission-icon" />;
    default:
      return <div className="circle-index fill">{currentIndex}</div>;
  }
};

export default IconMap;
